const LAYOUT_VERSION = {
  new: 'new',
  legacy: 'legacy',
} as const

export type LayoutVersion = typeof LAYOUT_VERSION[keyof typeof LAYOUT_VERSION]

/** Integer sent to GA as `nav_version`: 1 = legacy chrome, 2 = new chrome (header + navbar). */
export function resolveLayoutVersionNumber(isNewLayoutVersion: boolean): 1 | 2 {
  return isNewLayoutVersion ? 2 : 1
}

// append nav version to source when adding items to the cart
export function appendNavVersionToSource(source: string | undefined, navVersion: 1 | 2): string {
  const base = source
    || (import.meta.client ? location.href : '')
  if (!base)
    return String(navVersion)

  try {
    const url = new URL(base)
    url.searchParams.set('nav_version', String(navVersion))
    return url.toString()
  }
  catch {
    const separator = base.includes('?') ? '&' : '?'
    return `${base}${separator}nav_version=${navVersion}`
  }
}

export function useLayoutVersion() {
  const { feature } = useCountryConfig()
  const version = useCookie<LayoutVersion>('layout-version', {
    default: () => LAYOUT_VERSION.legacy,
    maxAge: 60 * 60 * 24 * 365,
  })

  const isNew = computed({
    get: () => Boolean(feature.displayLayoutVersionToggle && version.value === LAYOUT_VERSION.new),
    set: (value: boolean) => {
      version.value = value ? LAYOUT_VERSION.new : LAYOUT_VERSION.legacy
    },
  })

  return { version, isNew }
}
